import * as React from 'react';
import "./Modal.css";

interface IModalProps {
    name: string;
    shortDescription: string;
    longDescription: string;
    src: string;
    toggleModal: () => void;
}

class Modal extends React.Component<IModalProps, {}> {
    public description() {

        // A trick for comparing HTML with plain text,
        // to prevent duplicate texts if long and short description are the same.
        const tmp = document.createElement("DIV");
        tmp.innerHTML = this.props.longDescription;
        const longDesc = tmp.textContent || tmp.innerText || "";

        let html = this.props.shortDescription;
        if (html !== longDesc) {
            html += `<br /><br />${longDesc}`;
        }

        return { __html: html };
    }

    public render() {
        return (
            <div onClick={this.props.toggleModal} className="modal foc">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close">×</button>
                        </div>
                        <div className="modal-body">
                            <div className="product details">
                                <img src={this.props.src} alt={this.props.name} />
                                <h3>{this.props.name}</h3>
                                <div className="channelDescription" dangerouslySetInnerHTML={this.description()} />
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;